import React from 'react';

import { RadioGroup, FormControlLabel, Radio, FormControl, FormLabel } from '@mui/material';
import { Controller } from 'react-hook-form';

import { useFormContext, getFieldErrorMessage } from '../FormProvider';

interface Props {
  name: string;
  label: string;
  options: { value: string; label: React.ReactNode }[];
  row?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  margin?: 'none' | 'dense' | 'normal';
}

export const ControlledRadioGroupField: React.FC<Props> = ({
  name,
  label,
  options,
  row = false,
  disabled = false,
  fullWidth = true,
  margin = 'normal',
}) => {
  const { control, errors } = useFormContext();

  return (
    <FormControl fullWidth={fullWidth} margin={margin}>
      <FormLabel id={name}>{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup {...field} row={row}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio disabled={disabled} />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        )}
      />
      {errors?.[name] && <p style={{ color: 'red' }}>{getFieldErrorMessage(errors[name])}</p>}
    </FormControl>
  );
};
